module.exports = ".align-buttons {\n  text-align: right; }\n\n.buttonMassive {\n  padding: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-preventive-maintenance/master-preventive-maintenance.component.scss
// module id = ./src/app/master/master-preventive-maintenance/master-preventive-maintenance.component.scss
// module chunks = main